import { PageHeader } from '@blimo/ui';
import { DocumentManager } from '../../components/documents/document-manager.jsx';

/** Dokumente › Formulare & Downloads (F-407): globale Ordner, im Portal für alle Benutzer. */
export function DocumentFormsPage() {
  return (
    <>
      <PageHeader
        title="Formulare & Downloads"
        description="Allgemeine Dokumente ohne Objektbezug – z. B. SEPA-Mandat, Formulare, Merkblätter. Im Portal für alle Benutzer sichtbar, sobald veröffentlicht; die Reihenfolge (Pfeile) gilt auch im Portal."
      />
      <DocumentManager ownerType="global" title="Formulare & Downloads" />
    </>
  );
}
